var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showcomponents)?_c('div',[_c('topHead'),_vm._v(" "),_c('navLeft',{on:{"setPage":_vm.changePage}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('transition',{attrs:{"name":"move"}},[_c(_vm.currentPage,{tag:"component"})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4ec193d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/modelBox.vue
// module id = 704j
// module chunks = 1